import React, { useEffect, useMemo, useState } from 'react';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import idConfig from 'utils/ecommerce/services/id.config';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';

const extendRoamingInternational = (Component: (props: any) => JSX.Element) => {
	return (props: any) => {
		const [roamingDetails, setRoamingDetails] = useState<types.services.IPackageDetails | null>(null);
		const [internationalDetails, setInternationalDetails] = useState<types.services.IPackageDetails | null>(null);

		useEffect(() => {
			ECommerceService.getContentBySearchTerm(idConfig.INTERNATIONAL.legacyProductId).subscribe(
				({ response }) => {
					if (response.catalogEntryView && response.catalogEntryView[0]) {
						const selectedCatalogEntryView = response.catalogEntryView[0];
						const ebuConfigProduct = extractAttributeValue(
							{ attributes: selectedCatalogEntryView.attributes },
							CustomAttribute.EBU_CONFIG_PRODUCT
						);
						const place = extractAttributeValue(
							{ attributes: selectedCatalogEntryView.attributes },
							CustomAttribute.DEFINITION_SOURCE
						);
						setInternationalDetails({ place, ebuConfigProduct });
					}
				}
			);
		}, []);

		useEffect(() => {
			ECommerceService.getContentBySearchTerm(idConfig.ROAMING.legacyProductId).subscribe(({ response }) => {
				if (response?.catalogEntryView?.[0]) {
					const selectedCatalogEntryView = response.catalogEntryView[0];
					const ebuConfigProduct = extractAttributeValue(
						{ attributes: selectedCatalogEntryView.attributes },
						CustomAttribute.EBU_CONFIG_PRODUCT
					);
					const place = extractAttributeValue(
						{ attributes: selectedCatalogEntryView.attributes },
						CustomAttribute.DEFINITION_SOURCE
					);
					setRoamingDetails({ place, ebuConfigProduct });
				}
			});
		}, []);

		const internationalPackage = useMemo(
			() => ({
				place: internationalDetails?.place || idConfig.INTERNATIONAL.place,
				ebuConfigProduct: internationalDetails?.ebuConfigProduct,
			}),
			[internationalDetails]
		);

		const roamingPackage = useMemo(
			() => ({
				place: roamingDetails?.place || idConfig.INTERNATIONAL.place,
				ebuConfigProduct: roamingDetails?.ebuConfigProduct,
			}),
			[roamingDetails]
		);

		return <Component {...props} internationalPackage={internationalPackage} roamingPackage={roamingPackage} />;
	};
};

export default extendRoamingInternational;
